// extracted by mini-css-extract-plugin
export default {"feedbackModal":"Feedback_feedbackModal__pkn7t","closeHolder":"Feedback_closeHolder__jLGtC","closeButton":"Feedback_closeButton__KNQOH"};